<div class="row">
  <div class="col-md-6">
    <div class="card mt-2">
      <div class="card-body">
        <div class=" modal-header">
          <h5 class="modal-title">
            <i class='bx bx-lock'></i>Change Password
          </h5>
        </div>
        <form [formGroup]="changePasswordForm" (ngSubmit)="OnSubmit()">
          <div class="mb-3 mt-2">
            <label for="username" class="form-label">User Name:</label>
            <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                  class='bx bx-user-plus'></i></span>
              <input id="username" type="text" formControlName="username" readonly
                [ngModel]="employee?.userData?.username||session?.name" class="form-control ps-1">
            </div>
          </div>
          <div class="col-md-12 mb-2">
            <label for="password" class="form-label">Old Password<b class="text-secondary">*</b></label>
            <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                  class='bx bx-lock'></i></span>
              <input type="password" class="form-control ps-1" id="password" placeholder="Enter password" #password
                [ngClass]="{'is-invalid': submitted && c.oldPass.errors}" formControlName="oldPass" autocomplete="off"
                (copy)="$event.preventDefault()" (cut)="$event.preventDefault()" (paste)="$event.preventDefault()" />
              <span class="symbol-eye" *ngIf="!(submitted && c.oldPass.errors)">
                <i [class]="password.type==='password'? 'bx bx-low-vision':'bx bx-show'"
                  (click)="showPassword(password)"></i>
              </span>
              <div class="invalid-feedback" *ngIf="submitted && c?.oldPass?.errors">
                <span *ngIf="c?.oldPass?.errors?.required">Please provide a valid password.</span>
                <span *ngIf="c?.oldPass?.errors?.pattern">Invalid format e.g. "Admin$12"</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-2">
            <label for="newPassword" class="form-label">New Password<b class="text-secondary">*</b></label>
            <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                  class='bx bx-lock'></i></span>
              <input type="password" class="form-control ps-1" id="newPassword" placeholder="Enter password" #newPass
                [ngClass]="{'is-invalid': submitted && c.newPass.errors}" formControlName="newPass" autocomplete="off"
                (copy)="$event.preventDefault()" (cut)="$event.preventDefault()" (paste)="$event.preventDefault()" />
              <span class="symbol-eye" *ngIf="!(submitted && c.newPass.errors)">
                <i [class]="newPass.type==='password'? 'bx bx-low-vision':'bx bx-show'"
                  (click)="showPassword(newPass)"></i>
              </span>
              <div class="invalid-feedback" *ngIf="submitted && c?.newPass?.errors">
                <span *ngIf="c?.newPass?.errors?.required">Please provide a valid password.</span>
                <span *ngIf="c?.newPass?.errors?.pattern">Invalid format e.g. "Admin$12"</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-2">
            <label for="confirm" class="form-label">Confirm Password<b class="text-secondary">*</b></label>
            <div class="input-group">
              <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-lock'></i></span>
              <input type="password" class="form-control ps-1" id="confirm" placeholder="Enter confirm Password"
                #confirm [required]="c?.confirm?.value" formControlName="confirm"
                [ngClass]="{'is-invalid': submitted && (c?.confirm?.errors || (c?.confirm?.value !== c?.newPass?.value))}"
                autocomplete="off" (copy)="$event.preventDefault()" (cut)="$event.preventDefault()"
                (paste)="$event.preventDefault()" />
              <span class="symbol-eye"
                *ngIf="!(submitted && (c.confirm.errors || (c?.confirm?.value !== c?.newPass?.value)))">
                <i [class]="confirm.type === 'password' ? 'bx bx-low-vision' : 'bx bx-show'"
                  (click)="showPassword(confirm)"></i>
              </span>
              <div class="invalid-feedback"
                *ngIf="submitted && (c?.confirm?.errors || (c?.confirm?.value !== c?.newPass?.value))">
                <span *ngIf="c.confirm.errors?.required">Please provide a valid password.</span>
                <span *ngIf="c.confirm.errors?.pattern">Invalid format e.g. "Admin$12"</span>
                <span *ngIf="!c.confirm.errors && (c?.confirm?.value !== c?.newPass?.value)">Newpassword and confirm
                  password don't match</span>
              </div>
            </div>
          </div>
          <div class="mb-3 text-end mt-3">
            <button type="submit" class="btn btn-secondary" #inProgress
              [ngClass]="{'no-event': inProgress?.value == 'true'}">
              <ng-container *ngIf="inProgress?.value == 'true'">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{c?.value?.id ? 'Updating...' : 'Saving...'}}
              </ng-container>
              <ng-container *ngIf="inProgress?.value != 'true'">
                Change Password
              </ng-container>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>